module.exports = __webpack_public_path__ + "img/preview.ca544fad.png";